module.exports = __webpack_public_path__ + "img/i-account-management-admin.ba5a7b27.svg";